import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledDiv = styled.div`
  display: table-caption;
  height: ${(props) => props.style.height || '1.5rem'};
  text-align: ${(props) => props.style.textAlign || 'center'};
  font-family: ${(props) => props.style.fontFamily};
  font-size: ${(props) => props.style.fontSize};
  font-weight: ${(props) => props.style.fontWeight};
  color: ${(props) => props.style.color || '#000'};
  border: ${(props) => props.style.border || '0'};
  cursor: ${(props) => props.style.cursor || 'auto'};
`;

const Caption = ({
  hideCaption,
  style,
  formatCaption,
  onClick,
  date,
  months,
  locale,
  localeUtils,
}) =>
  !hideCaption && (
    <StyledDiv style={style} onClick={onClick} role="heading">
      {formatCaption({
        date,
        months,
        locale,
        localeUtils,
      })}
    </StyledDiv>
  );

Caption.defaultProps = {
  hideCaption: false,
  date: null,
  months: null,
  locale: null,
  localeUtils: null,
  onClick: null,
  formatCaption: ({ date, months, locale, localeUtils }) =>
    months
      ? `${months[date.getMonth()]} ${date.getFullYear()}`
      : localeUtils.formatMonthTitle(date, locale),
  style: {},
};

Caption.propTypes = {
  hideCaption: PropTypes.bool,
  // `react-day-picker` Caption propTypes, currently not exposed
  date: PropTypes.instanceOf(Date),
  months: PropTypes.arrayOf(PropTypes.string),
  locale: PropTypes.string,
  localeUtils: PropTypes.shape({
    formatMonthTitle: PropTypes.func,
  }),
  onClick: PropTypes.func,

  formatCaption: PropTypes.func,
  style: PropTypes.shape({
    height: PropTypes.string,
    textAlign: PropTypes.string,
    fontFamily: PropTypes.string,
    fontSize: PropTypes.string,
    fontWeight: PropTypes.string,
    color: PropTypes.string,
    border: PropTypes.string,
    cursor: PropTypes.string,
  }),
};

export default Caption;
